<gp-tag [attr.adapt]="adapt || null" [textColor]="textColor" [backgroundColor]="backgroundColor">
  <ng-content></ng-content>
</gp-tag>
